import cn from "classnames";
import { Card } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({ className = "", name, title, image }) {
  return (
    <Card className={cn(className, classes.AwardCard)}>
      {image && (
        <Card.Img as="div">
          <img src={image} alt={name} loading="lazy" />
        </Card.Img>
      )}
      <Card.Body className="text-center px-0 pb-0">
        <Card.Title as="h6" className="mb-2">
          {name}
        </Card.Title>
        {title && (
          <Card.Subtitle as="p" className="mb-0">
            {title}
          </Card.Subtitle>
        )}
      </Card.Body>
    </Card>
  );
}
